import React from 'react';
import Navbar from './navbar';
import Module1 from './module1';
import Module2 from './module2';
import Module3 from './module3';
import Module4 from './module4';
import Module5 from './module5';
import Module6 from './module6';
import Module7 from './module7';
import Module8 from './module8';
import Module9 from './module9';
import Module10 from './module10';
import Footer from './footer';

const LandingPage = () => {
  return (
    <>
      <Navbar />
      <Module1 />
      <Module2 />
      <Module3 />
      <Module4 />
      <Module5 />
      <Module6 />
      <Module7 />
      <Module8 />

      <Module9 />
      <Module10 />
      <Footer />
    </>
  );
};

export default LandingPage;
